import { createReducer } from '@mews/framework';

const initialState = {};

export const globalization = createReducer(initialState, {});
